// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_wrapper__17z3a {
  display: flex;
  flex-direction: column;
  gap: 48px;
}

.styles_gridWrapper__1fMwa {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 24px;
}
@media (max-width: 768px) {
  .styles_gridWrapper__1fMwa {
    grid-template-columns: 1fr;
  }
}

.styles_inputWrapper__MoG0W {
  width: 100%;
  display: flex;
  gap: 24px;
}
@media (max-width: 1920px) {
  .styles_inputWrapper__MoG0W {
    display: grid;
    grid-template-columns: 4fr 1fr;
  }
}
@media (max-width: 576px) {
  .styles_inputWrapper__MoG0W {
    flex-direction: column;
  }
}

.styles_totalWrapper__cLL1j {
  width: 100%;
  max-width: 334px;
}
@media (max-width: 992px) {
  .styles_totalWrapper__cLL1j {
    align-self: center;
  }
}
@media (max-width: 576px) {
  .styles_totalWrapper__cLL1j {
    max-width: 100%;
  }
}

.styles_btnWrapper__ctL-G {
  width: 100%;
  max-width: 334px;
  height: 57px;
}
@media (max-width: 992px) {
  .styles_btnWrapper__ctL-G {
    align-self: center;
  }
}
@media (max-width: 576px) {
  .styles_btnWrapper__ctL-G {
    max-width: 100%;
  }
}

.styles_checkoutBlock__\\+AWZe {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.styles_modalWrapper__Q3pVH {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.styles_subheading__G-k6q {
  font-weight: 300;
  font-size: 18px;
  line-height: 22px;
  letter-spacing: -0.015em;
  text-transform: capitalize;
  color: rgba(255, 255, 255, 0.8);
}
@media (max-width: 1200px) {
  .styles_subheading__G-k6q {
    font-size: 16px;
    line-height: 20px;
  }
}

.styles_valueGrid__8eqG5 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 16px;
}
@media (max-width: 576px) {
  .styles_valueGrid__8eqG5 {
    grid-template-columns: 1fr;
  }
}

.styles_valueWrapper__-Lg6K,
.styles_valueContractWrapper__NTtbT {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

@media (max-width: 1200px) {
  .styles_valueContractWrapper__NTtbT {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}

.styles_valueHeading__H9uNI {
  font-weight: 300;
  font-size: 16px;
  line-height: 20px;
  letter-spacing: -0.015em;
  color: rgba(255, 255, 255, 0.5);
}
@media (max-width: 1200px) {
  .styles_valueHeading__H9uNI {
    font-size: 12px;
    line-height: 15px;
  }
}

.styles_value__I4dQV,
.styles_valueContract__Jg3-N {
  font-weight: 800;
  font-size: 18px;
  line-height: 30px;
  letter-spacing: -0.015em;
  color: #ffffff;
}
@media (max-width: 1200px) {
  .styles_value__I4dQV,
.styles_valueContract__Jg3-N {
    font-size: 16px;
    line-height: 20px;
  }
}

.styles_valueContract__Jg3-N {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
@media (max-width: 1200px) {
  .styles_valueContract__Jg3-N {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/TokenCreator/content/tokenCreation/baseContent/fixedContent/styles.module.scss","webpack://./src/assets/styles/mixin/breakpoints.scss","webpack://./src/assets/styles/variables/colors.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAFF;;AAKA;EACE,aAAA;EACA,qCAAA;EACA,cAAA;AAFF;ACqBE;EDtBF;IAMI,0BAAA;EADF;AACF;;AAIA;EACE,WAAA;EACA,aAAA;EACA,SAAA;AADF;ACpBE;EDkBF;IAMI,aAAA;IACA,8BAAA;EAAF;AACF;ACUE;EDlBF;IAWI,sBAAA;EACF;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;AACF;ACZE;EDSF;IAKI,kBAAA;EAEF;AACF;ACLE;EDHF;IASI,eAAA;EAGF;AACF;;AAAA;EACE,WAAA;EACA,gBAAA;EACA,YAAA;AAGF;AC5BE;EDsBF;IAMI,kBAAA;EAIF;AACF;ACrBE;EDUF;IAUI,eAAA;EAKF;AACF;;AAFA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAKF;;AAFA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAKF;;AAFA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,0BAAA;EACA,+BEvES;AF4EX;ACjEE;EDsDF;IASI,eAAA;IACA,iBAAA;EAMF;AACF;;AAHA;EACE,aAAA;EACA,8BAAA;EACA,qBAAA;AAMF;AC3DE;EDkDF;IAMI,0BAAA;EAOF;AACF;;AAJA;;EAEE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAOF;;AC1FE;EDsFF;IAEI,sBAAA;IACA,uBAAA;IACA,QAAA;EAOF;AACF;;AAJA;EACE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,+BEhHS;AFuHX;AC1GE;ED8FF;IAQI,eAAA;IACA,iBAAA;EAQF;AACF;;AALA;;EAEE,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,wBAAA;EACA,cEpIM;AF4IR;ACzHE;ED2GF;;IASI,eAAA;IACA,iBAAA;EAUF;AACF;;AAPA;EACE,uBAAA;EACA,gBAAA;EACA,mBAAA;AAUF;ACtIE;EDyHF;IAMI,WAAA;EAWF;AACF","sourcesContent":["@import './src/assets/styles/mixin/breakpoints';\n@import './src/assets/styles/variables/colors';\n\n.wrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 48px;\n}\n\n.gridWrapper {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-gap: 24px;\n\n  @include md {\n    grid-template-columns: 1fr;\n  }\n}\n\n.inputWrapper {\n  width: 100%;\n  display: flex;\n  gap: 24px;\n\n  @include xxxxl {\n    display: grid;\n    grid-template-columns: 4fr 1fr;\n  }\n\n  @include sm {\n    flex-direction: column;\n  }\n}\n\n.totalWrapper {\n  width: 100%;\n  max-width: 334px;\n\n  @include lg {\n    align-self: center;\n  }\n\n  @include sm {\n    max-width: 100%;\n  }\n}\n\n.btnWrapper {\n  width: 100%;\n  max-width: 334px;\n  height: 57px;\n\n  @include lg {\n    align-self: center;\n  }\n\n  @include sm {\n    max-width: 100%;\n  }\n}\n\n.checkoutBlock {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.modalWrapper {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.subheading {\n  font-weight: 300;\n  font-size: 18px;\n  line-height: 22px;\n  letter-spacing: -0.015em;\n  text-transform: capitalize;\n  color: $white-80;\n\n  @include xl {\n    font-size: 16px;\n    line-height: 20px;\n  }\n}\n\n.valueGrid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  grid-column-gap: 16px;\n\n  @include sm {\n    grid-template-columns: 1fr;\n  }\n}\n\n.valueWrapper,\n.valueContractWrapper {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.valueContractWrapper {\n  @include xl {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n}\n\n.valueHeading {\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 20px;\n  letter-spacing: -0.015em;\n  color: $white-50;\n\n  @include xl {\n    font-size: 12px;\n    line-height: 15px;\n  }\n}\n\n.value,\n.valueContract {\n  font-weight: 800;\n  font-size: 18px;\n  line-height: 30px;\n  letter-spacing: -0.015em;\n  color: $white;\n\n  @include xl {\n    font-size: 16px;\n    line-height: 20px;\n  }\n}\n\n.valueContract {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n\n  @include xl {\n    width: 100%;\n  }\n}\n","@mixin xxxxl {\n  @media (max-width: 1920px) {\n    @content;\n  }\n}\n\n@mixin xxxl {\n  @media (max-width: 1700px) {\n    @content;\n  }\n}\n\n@mixin xxl {\n  @media (max-width: 1400px) {\n    @content;\n  }\n}\n\n@mixin xl {\n  @media (max-width: 1200px) {\n    @content;\n  }\n}\n\n@mixin lg {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n@mixin md {\n  @media (max-width: 768px) {\n    @content;\n  }\n}\n\n@mixin sm {\n  @media (max-width: 576px) {\n    @content;\n  }\n}\n","$white: #ffffff;\n$white-3: rgba($white, 0.03);\n$white-4: rgba($white, 0.04);\n$white-5: rgba($white, 0.05);\n$white-10: rgba($white, 0.1);\n$white-30: rgba($white, 0.3);\n$white-50: rgba($white, 0.5);\n$white-70: rgba($white, 0.7);\n$white-80: rgba($white, 0.8);\n$white-90: rgba($white, 0.9);\n$pink: #ff136d;\n$pink-10: rgba($pink, 0.1);\n$pink-15: rgba($pink, 0.15);\n$black: #000000;\n$black-5: rgba($black, 0.05);\n$black-15: rgba($black, 0.15);\n$black-26: rgba($black, 0.26);\n$black-30: rgba($black, 0.3);\n$black-70: rgba($black, 0.7);\n$black-87: rgba($black, 0.87);\n$black-bg: #100f0f;\n$black-nav-bg: #080808;\n$black-footer: #0a0a0a;\n$blue: #443de9;\n$blue-btn: #453fd6;\n$blue-btn-15: rgba($blue-btn, 0.15);\n$blue-btn-40: rgba($blue-btn, 0.4);\n$grey-nav: #b6b6b6;\n$grey-input: #414141;\n$orange: #f5b300;\n$orange-5: rgba($orange, 0.05);\n$green: #12bc56;\n$red: #d33030;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `styles_wrapper__17z3a`,
	"gridWrapper": `styles_gridWrapper__1fMwa`,
	"inputWrapper": `styles_inputWrapper__MoG0W`,
	"totalWrapper": `styles_totalWrapper__cLL1j`,
	"btnWrapper": `styles_btnWrapper__ctL-G`,
	"checkoutBlock": `styles_checkoutBlock__+AWZe`,
	"modalWrapper": `styles_modalWrapper__Q3pVH`,
	"subheading": `styles_subheading__G-k6q`,
	"valueGrid": `styles_valueGrid__8eqG5`,
	"valueWrapper": `styles_valueWrapper__-Lg6K`,
	"valueContractWrapper": `styles_valueContractWrapper__NTtbT`,
	"valueHeading": `styles_valueHeading__H9uNI`,
	"value": `styles_value__I4dQV`,
	"valueContract": `styles_valueContract__Jg3-N`
};
export default ___CSS_LOADER_EXPORT___;
